import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirects legacy `/mobile…` links to the equivalent `/govtid…` route,
 * preserving the query string. Replaces history so the `/mobile` URL is not
 * left on the back stack.
 */
const MobileAlias = () => {
    const { pathname, search } = useLocation();

    return <Navigate to={pathname.replace(/^\/mobile/, '/govtid') + search} replace />;
};

export default MobileAlias;
